import React, { useState } from "react";
import Contact from "../../assets/contact.jpg";
import ajp from "../../assets/ajp.jpg";
import { FiArrowUpRight } from "react-icons/fi";
import { MdOutlineMail } from "react-icons/md";
import { IoMdPhonePortrait } from "react-icons/io";
import { motion } from "framer-motion";

function Contactus() {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        country: "",
        phoneNumber: "",
        emailAddress: "",
        message: "",
    });

    const [openIndex, setOpenIndex] = useState(null);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };
    const containerVariants = {
        hidden: { opacity: 0, y: 50 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                staggerChildren: 0.3,
                duration: 1.6,
                ease: "easeOut",
            },
        },
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0 },
    };


    const faqItems = [
        {
            question: "How safe and secure are my apartments?",
            answer: `All our apartments have external CCTV with an optional camera in the living room
of the apartment for those wanting extra security. The buildings are housed to a
number of residents and tenants with 24-hour security alarms or personal patrolling.
You will be given a key/access card to move freely within the common areas at your liberty.`,
        },
        {
            question: "How many people can stay in my apartment?",
            answer: `Our Lohda apartment can accommodate 4 guests.
Our Kingston apartment can accommodate 6 guests.
Our studio apartment in Liverpool can accommodate 2 guests.`,
        },
        {
            question: "How well located is my apartment?",
            answer: `Both Lodha & Kingston Apartments:
- 10 Min Drive To Ruby Hall Hospital (Wanowrie)
- 20 Min Drive to MG Road
- 35 Min Drive to Koregoan Park
- 50 Min Drive to Baner
- 40 Min Drive to Pune Airport
- 3hr50 Min Drive To Mumbai Airport
These apartments are located within 10-minute walking distance from Tribeca & Dorabjee Mall. 
Liverpool accommodation is in prime city centre with a lock-box code provided for check-in.`,
        },
        {
            question: "What is included in the price of Accommodation?",
            answer: `A dedicated Concierge, car and driver, plus services listed on the apartments page.
Liverpool apartment is fully furnished but does not include concierge or chauffeur services.`,
        },
        {
            question: "Does my apartment have a concierge, what is he there for?",
            answer: `Yes, your apartment is looked after by Ian Langley, available for booking goods, 
restaurants, or coordinating with your driver. 
(Not available for Liverpool accommodation).`,
        },
        {
            question: "Is my chauffeur and vehicle included in the room rates?",
            answer: `Yes, available 9:00am–5:00pm daily (except Sundays). 
Overtime charges apply. Vehicle is limited to Pune City only. 
(Not available for Liverpool accommodation).`,
        },
        {
            question: "Can I cancel/change the Accommodation dates after payment?",
            answer: `You can cancel within 24 hours of payment. 
You can change dates free of cost up to 72 hours before your stay, subject to availability. 
No refunds if your new dates cannot be accommodated.`,
        },
    ];

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Form submitted:", formData);
    };

    return (
        <>
            <div>


                <section
                    className="min-h-screen bg-cover bg-center bg-no-repeat relative"
                    style={{
                        backgroundImage: `url(${Contact})`,
                    }}
                >
                    <div className="absolute inset-0 bg-black/70"></div>

                    <div className="relative z-10 container mx-auto px-4 py-8 lg:py-16 xl:py-24">
                        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 xl:gap-16 max-w-7xl mx-auto items-start">
                            {/* Left Content */}
                            <motion.div
                                className="text-white flex flex-col justify-start h-full py-6 lg:py-10 mt-5 md:mt-0"
                            >
                                {/* Heading & Paragraph */}
                                <motion.div
                                    variants={containerVariants}
                                    initial="hidden"
                                    whileInView="visible"
                                    viewport={{ once: true, amount: 0.3 }}
                                >
                                    <motion.h1
                                        variants={itemVariants}
                                        className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold font-[Raleway] leading-snug lg:leading-tight"
                                    >
                                        You Have Question,<br />We Have Answers
                                    </motion.h1>

                                    <motion.p
                                        variants={itemVariants}
                                        className="text-base sm:text-lg lg:text-xl text-white/90 leading-relaxed max-w-sm mx-0 mt-5 md:mx-0 lg:max-w-md"
                                    >
                                        Get in touch with us for appointments, treatments, Apartments,
                                        or any dental queries — our team is just a call or message away.
                                    </motion.p>
                                </motion.div>

                                {/* Email & Contact */}
                                <motion.div
                                    variants={{
                                        hidden: { opacity: 0, y: 50 },
                                        visible: {
                                            opacity: 1,
                                            y: 0,
                                            transition: {
                                                delayChildren: 1.2, // wait until heading & paragraph finish
                                                staggerChildren: 0.3,
                                                duration: 1.5,
                                                ease: "easeOut",
                                            },
                                        },
                                    }}
                                    initial="hidden"
                                    whileInView="visible"
                                    viewport={{ once: true, amount: 0.3 }}
                                    className="flex flex-col sm:flex-row lg:flex-row gap-6 sm:gap-8 lg:gap-12 xl:gap-24 mt-8 lg:mt-20"
                                >
                                    <motion.div variants={itemVariants} className="flex-1">
                                        <div className="flex items-center gap-3 mb-2">
                                            <motion.div
                                                whileHover={{ scale: 1.25 }}
                                                transition={{ type: "spring", stiffness: 30, damping: 20 }}
                                            >
                                                <MdOutlineMail className="text-2xl sm:text-2xl xl:text-2xl" />
                                            </motion.div>
                                            <span className="text-xl sm:text-2xl xl:text-2xl font-semibold">
                                                Email
                                            </span>
                                        </div>
                                        <p className="text-white/90 text-lg sm:text-xl xl:text-2xl">
                                            hospitality@ajpgroup.com
                                        </p>
                                    </motion.div>

                                    <motion.div variants={itemVariants} className="flex-1">
                                        <div className="flex items-center gap-3 mb-2">
                                            <motion.div
                                                whileHover={{ scale: 1.25 }}
                                                transition={{ type: "spring", stiffness: 30, damping: 20 }}
                                            >
                                                <IoMdPhonePortrait className="text-2xl sm:text-2xl xl:text-2xl" />
                                            </motion.div>
                                            <span className="text-xl sm:text-2xl xl:text-2xl font-semibold">
                                                Contact
                                            </span>
                                        </div>
                                        <p className="text-white/90 text-lg sm:text-xl xl:text-2xl">
                                            +91 8530255598
                                        </p>
                                    </motion.div>
                                </motion.div>
                            </motion.div>

                            {/* Contact Form */}
                            <div className="bg-gradient-to-b from-white to-[#F5E9D6] backdrop-blur-sm rounded-bl-[30px] rounded-tr-[30px] lg:rounded-tr-[50px] lg:rounded-bl-[50px] p-6 sm:p-8 lg:p-10 xl:p-12 shadow-2xl h-fit">
                                <div className="mb-6 lg:mb-8">
                                    <h2 className="text-2xl sm:text-3xl lg:text-2xl font-bold text-gray-900 mb-2 lg:mb-4 font-[Raleway]">
                                        Tell Us What You Need
                                    </h2>
                                    <p className="text-gray-600 font-normal font-[Rufina] text-lg lg:text-xl">
                                        Our team is here to help.
                                    </p>
                                </div>

                                <form onSubmit={handleSubmit} className="space-y-4 lg:space-y-6">
                                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
                                        <input
                                            type="text"
                                            name="firstName"
                                            placeholder="First Name"
                                            value={formData.firstName}
                                            onChange={handleInputChange}
                                            className="col-span-1 w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-slate-500 outline-none transition-all text-base lg:text-lg"
                                        />
                                        <input
                                            type="text"
                                            name="lastName"
                                            placeholder="Last Name"
                                            value={formData.lastName}
                                            onChange={handleInputChange}
                                            className="col-span-1 w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-slate-500 outline-none transition-all text-base lg:text-lg"
                                        />
                                        <input
                                            type="text"
                                            name="country"
                                            placeholder="Country"
                                            value={formData.country}
                                            onChange={handleInputChange}
                                            className="col-span-1 sm:col-span-2 lg:col-span-1 w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-slate-500 outline-none transition-all text-base lg:text-lg"
                                        />
                                    </div>

                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                                        <input
                                            type="tel"
                                            name="phoneNumber"
                                            placeholder="Phone Number"
                                            value={formData.phoneNumber}
                                            onChange={handleInputChange}
                                            className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-slate-500 outline-none transition-all text-base lg:text-lg"
                                        />
                                        <input
                                            type="email"
                                            name="emailAddress"
                                            placeholder="Email Address"
                                            value={formData.emailAddress}
                                            onChange={handleInputChange}
                                            className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-slate-500 outline-none transition-all text-base lg:text-lg"
                                        />
                                    </div>

                                    <textarea
                                        name="message"
                                        placeholder="Message"
                                        rows={5}
                                        value={formData.message}
                                        onChange={handleInputChange}
                                        className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-slate-500 outline-none transition-all resize-none text-base lg:text-lg"
                                    ></textarea>

                                    <div className="pt-2">
                                        <button
                                            type="submit"
                                            className="w-full bg-[#5B656F] hover:bg-slate-700 text-white font-semibold py-4 px-6 rounded-lg transition-colors duration-200 flex items-center justify-center gap-2 text-base lg:text-lg"
                                        >
                                            Submit
                                            <FiArrowUpRight className="text-xl" />
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="py-16 px-6 bg-gradient-to-b from-[#F5F3F1] to-[#F5E9D6]">
                    <div className="max-w-7xl mx-auto">
                        <div className="mb-4">
                            <span className="text-sm font-medium text-stone-600 uppercase tracking-wide font-[Lora]">
                                F&Q
                            </span>
                        </div>
                        <h2 className="text-4xl md:text-5xl font-medium text-[#313131] mb-12 font-[Raleway]">
                            GOT ANY QUESTIONS?
                        </h2>

                        <div className="bg-[#F5E9D6] px-6 md:px-10 py-8 md:py-10 rounded-lg shadow-sm">
                            <div className="space-y-2">
                                {faqItems.map((item, index) => (
                                    <div
                                        key={index}
                                        className={`border-stone-300 transition-all duration-300 ${index < faqItems.length - 1 ? 'border-b' : ''
                                            } ${openIndex === index ? 'pb-2' : ''}`}
                                    >
                                        {/* Question Button */}
                                        <button
                                            onClick={() => toggleFAQ(index)}
                                            className="flex items-center justify-between w-full py-5 px-4 hover:bg-orange-50/50 rounded-lg transition-all duration-300 group focus:outline-none focus:ring-2 focus:ring-orange-200 focus:ring-opacity-50"
                                            aria-expanded={openIndex === index}
                                            aria-controls={`faq-answer-${index}`}
                                        >
                                            <span className="text-left text-stone-700 text-base font-medium leading-relaxed font-[Raleway] transition-colors duration-300 group-hover:text-stone-900 pr-4">
                                                {item.question}
                                            </span>
                                            <svg
                                                className={`w-5 h-5 text-stone-600 transition-all duration-300 flex-shrink-0 ${openIndex === index
                                                    ? "rotate-90 transform text-stone-800 scale-110"
                                                    : "group-hover:scale-110 group-hover:text-stone-700"
                                                    }`}
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                                aria-hidden="true"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M9 5l7 7-7 7"
                                                />
                                            </svg>
                                        </button>

                                        {/* Animated Answer Container */}
                                        <div
                                            id={`faq-answer-${index}`}
                                            className={`overflow-hidden transition-all duration-500 ease-in-out ${openIndex === index
                                                ? "max-h-[500px] opacity-100 animate-slideDown"
                                                : "max-h-0 opacity-0"
                                                }`}
                                            role="region"
                                            aria-labelledby={`faq-question-${index}`}
                                        >
                                            <div className="px-4 pb-6 pt-1 md:mt-4">
                                                <div className="text-stone-600 text-sm md:text-base leading-relaxed font-[Raleway] animate-fadeIn">
                                                    {item.answer}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
}

export default Contactus;
